var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"question"},[(_vm.required)?_c('v-flex',{attrs:{"shrink":""}},[_c('RequiredMark')],1):_vm._e(),_c('v-flex',[_c('b',[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }